import { render } from "./OrderHistory.vue?vue&type=template&id=6b67affa"
import script from "./OrderHistory.vue?vue&type=script&lang=js"
export * from "./OrderHistory.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/shop/windowOverlay/OrderHistory.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6b67affa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6b67affa', __exports__)) {
    api.reload('6b67affa', __exports__)
  }
  
  module.hot.accept("./OrderHistory.vue?vue&type=template&id=6b67affa", () => {
    api.rerender('6b67affa', render)
  })

}


export default __exports__